import $ from 'jquery';

class Cims {

  constructor() {

  }

  setBodySizeClass() {
    // Add body-small class if window less than 768px
    if ($(window).width() < 769) {
      $('body').addClass('body-small');
    } else {
      $('body').removeClass('body-small');
    }
  }

  setupMenu() {
    // MetsiMenu
    $('#side-menu').metisMenu({
      toggle: false
    });

    // Minimalize menu
    $('.navbar-minimalize').on('click', (e) => {
      e.preventDefault();

      var $body = $("body");

      if ($body.hasClass('mini-navbar')) {
        Cookies.remove('menuCollapsed');
      }
      else {
        Cookies.set('menuCollapsed', 'true', { expires: 30 });
      }
      $body.toggleClass("mini-navbar");

      this.smoothlyMenu();
    });

    // Minimalize menu when screen is less than 768px
    $(window).bind("resize", () => {
      this.setBodySizeClass();
    });
  }

  setupIbox() {
    // Collapse ibox function
    $('.collapse-link').on('click', function () {
      var ibox = $(this).closest('div.ibox');
      var button = $(this).find('i');
      var content = ibox.find('div.ibox-content');
      content.slideToggle(200);
      button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      ibox.toggleClass('').toggleClass('border-bottom');
      setTimeout(function () {
        ibox.resize();
        ibox.find('[id^=map-]').resize();
      }, 50);
    });

    // Close ibox function
    $('.close-link').on('click', function () {
      var content = $(this).closest('div.ibox');
      content.remove();
    });

    // Fullscreen ibox function
    $('.fullscreen-link').on('click', function () {
      var ibox = $(this).closest('div.ibox');
      var button = $(this).find('i');
      $('body').toggleClass('fullscreen-ibox-mode');
      button.toggleClass('fa-expand').toggleClass('fa-compress');
      ibox.toggleClass('fullscreen');
      setTimeout(function () {
        $(window).trigger('resize');
      }, 100);
    });
  }

  smoothlyMenu() {
    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
      // Hide menu in order to smoothly turn on when maximize menu
      $('#side-menu').hide();
      // For smoothly turn on menu
      setTimeout(
        function () {
          $('#side-menu').fadeIn(400);
        }, 200);
    } else if ($('body').hasClass('fixed-sidebar')) {
      $('#side-menu').hide();
      setTimeout(
        function () {
          $('#side-menu').fadeIn(400);
        }, 100);
    } else {
      // Remove all inline style from jquery fadeIn function to reset menu state
      $('#side-menu').removeAttr('style');
    }
  }

  updateSelectAll(scope) {
    var $selectAll = $('.select-all');
    if (scope) {
      $selectAll = $selectAll.filter('[data-scope=' + scope + ']');
    }
    else {
      scope = $selectAll.data('scope');
    }

    var unchecked = $('input:checkbox:not(.select-all)[data-scope=' + scope + ']:not(:checked)').length;
    $selectAll.prop('checked', unchecked === 0);
  }

  setupSelectAll() {

    // Initialize select-all checkboxes
    let _this = this;

    this.updateSelectAll();

    $('.select-all').on('click', function () {
      let scope = $(this).data('scope');
      let isChecked = $(this).is(':checked');

      let $input = $('input:checkbox:not(.select-all)[data-scope=' + scope + ']')
        .prop('checked', isChecked);
      let $tr = $input.closest('tr');
      if (isChecked) {
        $tr.addClass('active');
      }
      else {
        $tr.removeClass('active');
      }
    });

    $('input:checkbox:not(.select-all)[data-scope]').on('click', function (e) {
      e.stopPropagation();
      var scope = $(this).data('scope');
      $(this).closest('tr').toggleClass('active');
      _this.updateSelectAll(scope);
    });

    $('[data-checkbox-toggle]').on('click', function() {
      $(this).find('input:checkbox').trigger('click');
    });
  }

  // Full height of sidebar
  fixHeight() {
    var $footer = $("body > #root > #wrapper > #page-wrapper > .footer");
    var footerHeight = $footer.height();
    var heightWithoutNavbar = $("body > #root > #wrapper").height() - 61;
    var windowHeight = $(window).height();
    var contentHeight = $('#page-wrapper > .wrapper-content').outerHeight();
    var pageWrapperHeight = $('#page-wrapper').outerHeight();
    var contentOffset = $('#page-wrapper > .wrapper-content').offset();
    var footerOverlap = footerHeight + contentHeight - pageWrapperHeight;
    if (contentOffset !== undefined) {
      footerOverlap += contentOffset.top;
    }

    $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = $('nav.navbar-default').height();
    var wrapperHeight = $('#page-wrapper').height();

    if (navbarHeight > wrapperHeight) {
      $('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if (navbarHeight < wrapperHeight) {
      $('#page-wrapper').css("min-height", windowHeight + "px");
      if (footerOverlap > 0) {
        $('#page-wrapper > .wrapper-content').css("margin-bottom", footerOverlap + "px");
      }
    }

    if ($('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        $('#page-wrapper').css("min-height", navbarHeight + "px");
      } else {
        $('#page-wrapper').css("min-height", windowHeight - 60 + "px");
      }
    }

    $footer.children().css('line-height', footerHeight + 'px');
  }

  fixSidebar() {
    // Fixed Sidebar
    $(window).bind("load", function () {
      if ($("body").hasClass('fixed-sidebar')) {
        $('.sidebar-collapse').slimScroll({
          height: '100%',
          railOpacity: 0.9
        });
      }
    });
  }

  setupWindow() {
    $(window).bind("load resize scroll", () => {
      if (!$("body").hasClass('body-small')) {
        this.fixHeight();
      }
    });
  }

  addSlimScroll() {
    // Add slimscroll to element
    $('.full-height-scroll').slimscroll({
      height: '100%'
    });
  }

  addIChecks() {
    $('.i-checks').each(function (ix) {
      let $this = $(this);
      let inheritClass = $this.data('icheck-inherit-class');
      if (inheritClass === undefined) inheritClass = true;
      $this.iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        inheritClass: inheritClass
      });
    });
  }

  addChosen() {
    $('.select-chosen').chosen({ width: '100%'});
  }

  addFooTable() {
    $('.footable').footable({
      paginate: false,
      createDetail: function (element, data, createGroupedDetail, separatorChar, classes) {
        /// <summary>This function is used by FooTable to generate the detail view seen when expanding a collapsed row.</summary>
        /// <param name="element">This is the div that contains all the detail row information, anything could be added to it.</param>
        /// <param name="data">
        ///  This is an array of objects containing the cell information for the current row.
        ///  These objects look like the below:
        ///    obj = {
        ///      'name': String, // The name of the column
        ///      'value': Object, // The value parsed from the cell using the parsers. This could be a string, a number or whatever the parser outputs.
        ///      'display': String, // This is the actual HTML from the cell, so if you have images etc you want moved this is the one to use and is the default value used.
        ///      'group': String, // This is the identifier used in the data-group attribute of the column.
        ///      'groupName': String // This is the actual name of the group the column belongs to.
        ///    }
        /// </param>
        /// <param name="createGroupedDetail">The grouping function to group the data</param>
        /// <param name="separatorChar">The separator charactor used</param>
        /// <param name="classes">The array of class names used to build up the detail row</param>

        // console.log(element);
        // console.log(data);
        // console.log(separatorChar);
        // console.log(classes);

        var groups = createGroupedDetail(data);
        for (var group in groups) {
          if (groups[group].data.length === 0) continue;
          if (group !== '_none') element.append('<div class="' + classes.detailInnerGroup + '">' + groups[group].name + '</div>');

          for (var j = 0; j < groups[group].data.length; j++) {
            var separator = (groups[group].data[j].name) ? separatorChar : '';
            element.append($('<div></div>').addClass(classes.detailInnerRow).append($('<div></div>').addClass(classes.detailInnerName)
              .append(groups[group].data[j].name + separator)).append($('<div></div>').addClass(classes.detailInnerValue)
                .attr('data-bind-value', groups[group].data[j].bindName).append(groups[group].data[j].display)));
          }
        }
      }
    });
  }

  addDataDependentFields() {
    var _this = this;
    $('[data-toggle="dependent"]').each(function() {
      var $d = $(this);
      var dependencies = $d.data('values');
      if (typeof dependencies === 'string') dependencies = JSON.parse(dependencies);
      var visible = true;
      for (let dependencyData of dependencies) {
        var dependency = $('#' + dependencyData.id);
        var dependencyValue = null;

        if (dependency.attr('type') === "checkbox") {
          dependencyValue = dependency.is(':checked');
        } else {
          dependencyValue = dependency.val();
        }

        if (dependencyData.function !== undefined) {
          if (dependencyData.function === 'startsWith') {
            if (dependencyData.value instanceof Array) {
              let anyVisible = false;
              dependencyData.value.forEach(v => anyVisible ||= dependencyValue.startsWith(v));
              visible &= anyVisible;
            } else {
              visible &= dependencyValue.startsWith(dependencyData.value);
            }
          }
          if (dependencyData.function === 'includes') {
            if (dependencyData.value instanceof Array) {
              let anyVisible = false;
              dependencyData.value.forEach(v => anyVisible ||= dependencyValue.includes(v));
              visible &= anyVisible;
            } else {
              visible &= dependencyValue.includes(dependencyData.value);
            }
          }
          if (dependencyData.function === 'endsWith') {
            if (dependencyData.value instanceof Array) {
              let anyVisible = false;
              dependencyData.value.forEach(v => anyVisible ||= dependencyValue.endsWith(v));
              visible &= anyVisible;
            } else {
              visible &= dependencyValue.endsWith(dependencyData.value);
            }
          }
        } else {
          if (dependencyData.value instanceof Array) {
            visible &= dependencyData.value.includes(dependencyValue);
          } else {
            visible &= dependencyValue === dependencyData.value;
          }
        }

        dependency.off('change').on('change', () => _this.addDataDependentFields());
      }
      // Set element visibility based on dependencies.
      $d.find('.form-control').prop('disabled', !visible);
      if (visible) {
        $d.removeClass('d-none');
        if ($d.find('select.form-control').data("chosen") !== undefined) $d.find('select.form-control').chosen('destroy').chosen();
      }
      else {
        $d.addClass('d-none');
        //$d.find('.form-control').val('');
      }
    });
  }

  addPopovers() {
    $('[data-toggle="popover"]').popover();
  }

  addTooltips() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  setDatepickerDefaults() {
    $.fn.datepicker.defaults.format = "mm/dd/yyyy";
    $.fn.datepicker.defaults.assumeNearbyYear = true;
    $.fn.datepicker.defaults.clearBtn = true;
  }

  addDateTimePickers() {
    $('.datetime-picker').datetimepicker({
      allowInputToggle: true
    });
  }

  addDatePickers() {
    $('.date-picker').datetimepicker({
      allowInputToggle: true,
      format: 'L'
    });
  }

  addDateTimePickersNoCurrent() {
    $('.datetime-picker-no-current').datetimepicker({
      allowInputToggle: true,
      useCurrent: false
    });
  }

  addDatePickersNoCurrent() {
    $('.date-picker-no-current').datetimepicker({
      allowInputToggle: true,
      format: 'L',
      useCurrent: false
    });
  }

  addLaddaButtons() {
    $('.btn-ladda').addClass('ladda-button')
      .attr('data-style', 'expand-left')
      .attr('data-size', 'sm')
      .each(function (ix, el) {
        Ladda.bind(el, { callback: instance => {
            $('.btn:enabled').not(el)
              .prop('disabled', true);
          }
        });
      });
  }

  spinOnClick() {
    $('.btn-spin-on-click')
      .find('i.fa')
      .on('click', e => $(e.currentTarget).addClass('fa-spin'));
  }

  start() {

    this.setDatepickerDefaults();
    this.setBodySizeClass();
    this.setupMenu();
    this.setupIbox();
    this.setupSelectAll();
    this.fixHeight();
    this.fixSidebar();
    this.setupWindow();
    this.addSlimScroll();
    this.addIChecks();
    this.addChosen();
    this.addFooTable();
    this.addPopovers();
    this.addTooltips();
    this.addDateTimePickers();
    this.addDatePickers();
    this.addDateTimePickersNoCurrent();
    this.addDatePickersNoCurrent();
    this.addDataDependentFields();
    this.addLaddaButtons();
    this.spinOnClick();
  }
}

export default new Cims();
